import React from 'react';

import { useTheme } from 'styled-components';

import Icon from 'shared/icons';

import { FilterDefaultChips, LeftIconWrapper } from './style';
import { IFilterChips } from './type';
import CoreSvg from '../CoreSvg';

const FilterDefault = ({
	value,
	selected,
	setSelected,
	_disabled = false,
}: IFilterChips) => {
	const theme = useTheme();
	return (
		<>
			<FilterDefaultChips
				selected={
					typeof selected === 'string' ? selected === value : selected?.includes(value)
				}
				disabled={_disabled}
				onClick={() => {
					if (_disabled) return;
					setSelected && setSelected(value);
				}}
			>
				{(typeof selected === 'string'
					? selected === value
					: selected?.includes(value)) && (
					<LeftIconWrapper>
						<CoreSvg _fill={theme.colors.gray.gray_white}>
							<Icon.Check />
						</CoreSvg>
					</LeftIconWrapper>
				)}
				{value}
			</FilterDefaultChips>
		</>
	);
};

export default FilterDefault;
